function getAPIGatewayBase(env, region, path) {
    switch (env) {
        case 'qa':
        case 'stg':
            // non-prod only has us region
            env = `us-${env}`;
            break;
        case 'uat':
            env = `${region}-${env}`;
            break;
        default:
            env = region;
            break;
    }
    return `https://www.${env}-api.morningstar.com/${path}`;
}

function getMarketsDomain(env, region) {
    // wait to implement once other region setup is done
    env = env.toLowerCase();
    if (env === 'qa' || env === 'stg') {
        return {
            web: `https://markets-service-${env}.morningstar.com/`,
            pull: `https://markets-service-${env}.morningstar.com/pullservice/`,
            push: `https://pushqs-${env}.qscb879.easn.morningstar.com`
        };
    } else if (env === 'uat') {
        return {
            web: 'https://markets-uat.morningstar.com/',
            pull: 'https://markets-uat.morningstar.com/pullservice/',
            push: 'https://pushqs-uat.morningstar.com'
        };
    } else {
        return {
            web: 'https://quotespeed.morningstar.com/',
            pull: 'https://pullqs.morningstar.com/pullservice/',
            push: 'https://pushqs.morningstar.com'
        };
    }
}

function marketsWeb({
    env,
    region,
    isAPIGateway = false,
    path,
    overridePaths = {}
} = {}) {
    const serviceKey = `@web/${path}`;
    if (overridePaths[serviceKey]) {
        return overridePaths[serviceKey];
    } else {
        let base;
        if (overridePaths['@web']) {
            base = overridePaths['@web'];
        }
        if (!base) {
            base = isAPIGateway
                ? getAPIGatewayBase(env, region, 'QS-markets/')
                : getMarketsDomain(env, region).web;
        }
        return `${base}${path}`;
    }
}

function marketsPull({
    env,
    region,
    isAPIGateway = false,
    path,
    overridePaths = {}
} = {}) {
    const serviceKey = `@pull/${path}`;
    if (overridePaths[serviceKey]) {
        return overridePaths[serviceKey];
    } else {
        let base;
        if (overridePaths['@pull']) {
            base = overridePaths['@pull'];
        }
        if (!base) {
            base = isAPIGateway
                ? getAPIGatewayBase(env, region, 'QS-pullqs/')
                : getMarketsDomain(env, region).pull;
        }
        return `${base}${path}`;
    }
}

function marketsPush({ env, region, overridePaths = {} } = {}) {
    if (overridePaths['@push']) {
        return overridePaths['@push'];
    } else {
        return `${getMarketsDomain(env, region).push}`;
    }
}

export default function url({
    serviceKey,
    env,
    region = 'us',
    isAPIGateway,
    overridePaths
} = {}) {
    if (!serviceKey) {
        throw new Error('Missing required argument serviceKey');
    }
    const keys = serviceKey.split('/');
    const urlType = keys[0];
    const path = keys.slice(1).join('/');
    let url;
    switch (urlType) {
        case '@web':
            url = marketsWeb({
                env,
                region,
                isAPIGateway,
                path,
                overridePaths
            });
            break;
        case '@pull':
            url = marketsPull({
                env,
                region,
                isAPIGateway,
                path,
                overridePaths
            });
            break;
        case '@push':
            url = marketsPush({
                env,
                region,
                overridePaths
            });
            break;
        default:
            url = serviceKey;
            break;
    }
    return url;
}
